"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _commonReact = require("@devsta/common-react");

var _getVideoOutputName = _interopRequireDefault(require("@devsta/get-video-output-name"));

var _SummarySection = _interopRequireDefault(require("./SummarySection"));

var _Output = _interopRequireDefault(require("./Output"));

var _Carousel = _interopRequireDefault(require("./Carousel"));

var _Footer = _interopRequireDefault(require("../../../components/Footer"));

require("../styles/_summary.scss");

var _utils = require("../../../../../common/utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var BRIEF_DIRECTION_MAP = {
  EXACT: 'PLEASE FOLLOW BRIEF EXACTLY',
  BRIEF: 'PLEASE FOLLOW BRIEF LOOSELY',
  FULL: 'PLEASE BE CREATIVE'
};

function hasAnyOutputWithCost(_ref) {
  var getAddonsCost = _ref.getAddonsCost,
      outputs = _ref.outputs;

  if (outputs.length > 1) {
    return true;
  }

  return outputs.reduce(function (hasCost, _ref2) {
    var versions = _ref2.versions;
    return Boolean(getAddonsCost(versions[0].appliedAddons, {
      numberValue: true
    }));
  }, false);
}

var Summary = /*#__PURE__*/function (_Component) {
  _inherits(Summary, _Component);

  var _super = _createSuper(Summary);

  function Summary() {
    var _this;

    _classCallCheck(this, Summary);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "getNumberComments", function (number) {
      var numberComments = _this.state.numberComments;

      if (number === numberComments) {
        return;
      }

      _this.setState({
        numberComments: number
      });
    });

    _defineProperty(_assertThisInitialized(_this), "saveVideo", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3) {
        var purchaseOrderId, teamId, _this$props, submitVideo, history, outputs, videoId, videoProjectId, _yield$submitVideo, error, masterOutput;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                purchaseOrderId = _ref3.purchaseOrderId, teamId = _ref3.teamId;
                _this$props = _this.props, submitVideo = _this$props.submitVideo, history = _this$props.history, outputs = _this$props.outputs, videoId = _this$props.videoId, videoProjectId = _this$props.videoProjectId;

                if (!(!videoId || !videoProjectId)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                _this.setState({
                  submitting: true
                });

                _context.next = 7;
                return submitVideo({
                  purchaseOrderId: purchaseOrderId,
                  teamId: teamId
                });

              case 7:
                _yield$submitVideo = _context.sent;
                error = _yield$submitVideo.error;

                if (!error) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return", void _this.setState({
                  submitting: false
                }));

              case 11:
                masterOutput = outputs.find(function (_ref5) {
                  var isMaster = _ref5.isMaster;
                  return isMaster;
                });

                if (masterOutput) {
                  _context.next = 14;
                  break;
                }

                return _context.abrupt("return", void history.push("video-tool/project/".concat(videoProjectId)));

              case 14:
                history.push("/review/".concat(videoId, "/").concat(masterOutput.outputId));

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onSubmit", function () {
      var openPaymentsInvoiceModal = _this.props.openPaymentsInvoiceModal;
      return void openPaymentsInvoiceModal();
    });

    _defineProperty(_assertThisInitialized(_this), "modifyAddons", function () {
      var goBack = _this.props.goBack;
      return void goBack();
    });

    _this.state = {
      submitting: false,
      numberComments: 0
    };
    return _this;
  }

  _createClass(Summary, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          assets = _this$props2.assets,
          goBack = _this$props2.goBack,
          outputs = _this$props2.outputs,
          notesToTheEditor = _this$props2.notesToTheEditor,
          creativeInput = _this$props2.creativeInput,
          history = _this$props2.history,
          canUpdateVideo = _this$props2.canUpdateVideo,
          hasUpdatePermission = _this$props2.hasUpdatePermission,
          costReviewEnabled = _this$props2.costReviewEnabled,
          hasCostApprovalPermission = _this$props2.hasCostApprovalPermission,
          videoName = _this$props2.videoName,
          getAddonsCost = _this$props2.getAddonsCost,
          clips = _this$props2.clips;
      var _this$state = this.state,
          submitting = _this$state.submitting,
          numberComments = _this$state.numberComments;
      return (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
          className: "video-summary column"
        }, /*#__PURE__*/_react.default.createElement(_SummarySection.default, {
          history: history,
          title: "Video Brief",
          icon: "brief",
          buttonText: canUpdateVideo ? 'MODIFY BRIEF' : 'VIEW BRIEF',
          stage: 3
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "video-summary__notes"
        }, creativeInput ? /*#__PURE__*/_react.default.createElement("p", null, BRIEF_DIRECTION_MAP[creativeInput]) : null, /*#__PURE__*/_react.default.createElement(_commonReact.RichTextEditor, {
          editorState: (0, _commonReact.convertToEditorState)((0, _utils.parseJson)(notesToTheEditor)),
          disabled: true
        }))), /*#__PURE__*/_react.default.createElement(_SummarySection.default, {
          history: history,
          title: "Video Outputs (".concat(outputs.length, ")"),
          icon: "package",
          buttonText: hasUpdatePermission ? 'MANAGE OUTPUTS' : 'VIEW OUTPUTS',
          stage: 4
        }, /*#__PURE__*/_react.default.createElement(_Carousel.default, null, outputs.map(function (output) {
          return (/*#__PURE__*/_react.default.createElement(_Output.default, _extends({
              title: (0, _getVideoOutputName.default)(output, videoName),
              key: output.outputId
            }, output))
          );
        }))), /*#__PURE__*/_react.default.createElement(_SummarySection.default, {
          title: "Asset Comments (".concat(numberComments, ")"),
          icon: "comments",
          buttonText: "VIEW COMMENTS",
          history: history,
          stage: 2
        }, /*#__PURE__*/_react.default.createElement(_commonReact.CommentsList, {
          className: "video-summary__comments",
          clips: clips,
          getNumberComments: this.getNumberComments
        })), /*#__PURE__*/_react.default.createElement(_SummarySection.default, {
          history: history,
          title: "Video Assets (".concat(assets.length, ")"),
          icon: "medialibrary",
          buttonText: canUpdateVideo ? 'MANAGE ASSETS' : 'VIEW ASSETS',
          stage: 1
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "video-summary__assets"
        }, /*#__PURE__*/_react.default.createElement(_Carousel.default, null, assets.map(function (assetId) {
          return (/*#__PURE__*/_react.default.createElement(_commonReact.AssetPreview, {
              key: assetId,
              assetId: assetId,
              height: "200px",
              width: "200px"
            })
          );
        }))))), /*#__PURE__*/_react.default.createElement(_Footer.default, {
          buttonText: costReviewEnabled && !hasCostApprovalPermission && hasAnyOutputWithCost({
            outputs: outputs,
            getAddonsCost: getAddonsCost
          }) ? 'SUBMIT FOR REVIEW - APPROVAL' : 'CONFIRM & SUBMIT VIDEO',
          onBackClick: goBack,
          onNext: canUpdateVideo ? this.onSubmit : void 0,
          nextBusy: submitting
        }))
      );
    }
  }]);

  return Summary;
}(_react.Component);

exports.default = Summary;